"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const StyledParagraph = /*#__PURE__*/_styledComponents.default.p.withConfig({
  displayName: "Paragraph__StyledParagraph",
  componentId: "components-web__sc-1bg9r8p-0"
})(["", " ", " &:first-child{margin-block-start:0em;}&:last-child{margin-block-end:0em;}"], _ref => {
  let {
    align
  } = _ref;
  return align ? `text-align: ${align};` : '';
}, _ref2 => {
  let {
    linesBetween
  } = _ref2;
  return `
    margin-block-start: ${linesBetween}em;
    margin-block-end: ${linesBetween}em;
  `;
});

/**
* Block text as an HTML ```<p>``` element.
	*
	* ##Usage criteria
	*
	* - All body text should be contained in a **Paragraph**, regardless of length.
	* - If the Paragraph is on a dark background, variant **{ invert: true }** must be used to maintain sufficient colour
	contrast.
	* - All Allium Typography variants other than header size variants are supported.
	*/
const Paragraph = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    children,
    variant,
    tokens,
    testID,
    align,
    linesBetween = 1,
    ...rest
  } = _ref3;
  const style = (0, _utils.useTypographyTheme)(variant, tokens);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledParagraph, {
    ref: ref,
    linesBetween: linesBetween,
    "data-testid": testID,
    align: align,
    style: style,
    ...selectProps(rest),
    children: children
  });
});
Paragraph.displayName = 'Paragraph';
Paragraph.propTypes = {
  ...selectedSystemPropTypes,
  children: _propTypes.default.node.isRequired,
  /**
   * Adds a `data-testid` attribute to the element for testing purposes
   */
  testID: _propTypes.default.string,
  /**
   * Sets the alignment style for the paragraph. Same options as Typography's `align` prop.
   * 'justify' should be avoided as it usually reduces ease of reading.
   */
  align: _propTypes.default.oneOf(['auto', 'left', 'right', 'center', 'justify']),
  /**
   * How much space between consecutive paragraphs, or between a paragraph and its siblings, in CSS
   * `em` units: 1 gives space equal to one line of paragraph text, 0.5 would be half a line, etc.
   * @default 1
   */
  linesBetween: _propTypes.default.number,
  /**
   * Paragraph takes the same tokens overrides as Typography
   */
  tokens: (0, _componentsBase.getTokensPropType)('Typography'),
  /**
   * Paragraph takes any of Typography's theme variants except for header sizes
   */
  variant: _propTypes.default.exact({
    bold: _propTypes.default.bool,
    colour: _propTypes.default.oneOf(['secondary', 'tertiary']),
    inverse: _propTypes.default.bool,
    size: _propTypes.default.oneOf(['micro', 'small', 'large'])
  })
};
var _default = exports.default = Paragraph;